<template>
  <layout-main-inner :title="$route.query.productId ? '编辑商品备案': '新增商品备案'">
    <!-- <template slot="append">
      <span
        v-if="userPermission.SUPERVISE || userPermission.OPERATE"
        style="color:#888">({{ productInfo.vendorName }})</span>
    </template> -->
    <el-button
      v-if="$route.query.productId"
      slot="action"
      type="primary"
      :loading="loading"
      @click="update">更新</el-button>
    <el-form
      ref="ruleForm"
      :model="productInfo"
      :rules="rules"
      label-position="top">
      <layout-card-wrap
        v-loading="loading"
        hasHeaderSlot>
        <template slot="title">基本信息</template>
        <el-row
          type="flex"
          :gutter="20">
          <el-col :span="8">
            <el-form-item
              label="商品名称:"
              prop="productName">
              <!-- <el-input v-model="productInfo.productName"></el-input> -->
              <span>{{ productInfo.productName || '-' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="商品编号:"
              prop="productNumber">
              <!-- <el-input v-model="productInfo.productNumber"></el-input> -->
              {{ productInfo.productNumber || '-' }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="商品规格:"
              prop="productNameRemark">
              <el-input v-model="productInfo.productNameRemark"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="商品品种:"
              prop="categoryId">
              <vendor-category-select
                v-model="productInfo.categoryId"
                style="width: 100%"
                :option="{vendorId: productInfo.vendorId}" />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item
              label="商品系列:"
              prop="categoryId">
              <vendor-series-select
                v-model="productInfo.productLineNo"
                style="width: 100%"
                :option="{vendorId: productInfo.vendorId}" />
            </el-form-item>
          </el-col> -->
          <el-col :span="24">
            <el-form-item
              label="商品图片:"
              prop="productImages">
              <upload-image
                v-model="productInfo.productImages"
                cropper
                :fixedNumber="[5,3]"
                :autoCropWidth="300"
                :autoCropHeight="180"
                :limit="5" />
            </el-form-item>
          </el-col>
        </el-row>
      </layout-card-wrap>
      <layout-card-wrap
        v-loading="loading"
        hasHeaderSlot
        style="margin-top:8px">
        <template slot="title">其他信息</template>
        <el-row
          type="flex"
          :gutter="20">
          <template v-for="(item, index) in productInfo.baseFields">
            <el-col
              :key="item.name"
              :span="item.type==='IMAGE' ? 24 : 8">
              <smart-form
                :item="item"
                :vendorId="productInfo.vendorId"
                :cb="callback"
                :prop="'baseFields.' + index + '.fieldValue'" />
            </el-col>
          </template>
          <template v-for="(item, index) in productInfo.extraFields">
            <el-col
              :key="item.name"
              :span="item.type==='IMAGE' ? 24 : 8">
              <smart-form
                :item="item"
                :vendorId="productInfo.vendorId"
                :prop="'extraFields.' + index + '.fieldValue'" />
            </el-col>
          </template>
        </el-row>
      </layout-card-wrap>
    </el-form>
    <template slot="footer">
      <!-- <back-button ref="back" /> -->
      <!-- <el-button
        v-if="$route.query.productId"
        type="primary"
        :loading="loading"
        @click="update">更新</el-button> -->
      <!-- <el-button
        v-else
        type="primary"
        :loading="loading"
        @click="save">保存</el-button> -->
    </template>
  </layout-main-inner>
</template>
<script>
// import TradeRadioBox from './busi/trade-radio-box.vue'
// import CodingRadioBox from './busi/coding-radio-box.vue'
// import VendorLabelSelect from './busi/vendor-label-select.vue'
import VendorCategorySelect from './busi/vendor-category-select.vue'
import UploadImage from '@/components/public/upload-image-new.vue'
import '@/components/business/custom-form/index'
import clonedeep from 'lodash.clonedeep'
import Utils from './busi/utils.js'
import TemplateFormat from '@/utils/templateFormat'
import { mapState } from 'vuex'
// import VendorSeriesSelect from './busi/vendor-series-select.vue'VendorSeriesSelect,
export default {
  name: 'ProductEdit',
  components: { VendorCategorySelect, UploadImage },
  data() {
    return {
      loading: false,
      productInfo: {
        categoryId: null,
        tradeType: 1,
        codingType: 1,
        tagType: null
      },
      init: true,
      rules: Utils.rules,
      codingTypeDisabled: false
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission
    }),
    templateTriggerInfo() {
      return {
        categoryId: this.productInfo.categoryId,
        tradeType: this.productInfo.tradeType
      }
    }
  },
  watch: {
    templateTriggerInfo: {
      handler(val) {
        if (!this.init && val.categoryId && val.tradeType) {
          this.getcategorytemplate({
            classId: val.categoryId,
            tradeType: val.tradeType
          })
        }
      },
      deep: true
    },
    'productInfo.tagType': {
      handler(val) {
        if (val === 1) {
          this.codingTypeDisabled = true
          this.productInfo.codingType = 1
        } else {
          this.codingTypeDisabled = false
        }
      }
    }
  },
  mounted() {
    if (this.$route.query.productId) {
      this.getproduct({
        vendorId: this.$route.query.vendorId,
        productId: this.$route.query.productId
      })
    } else {
      this.productInfo = {
        vendorId: this.$route.query.vendorId,
        status: 2,
        productName: '',
        productNameRemark: '',
        productNumber: '',
        categoryId: null,
        tradeType: 1,
        codingType: 1,
        tagType: null,
        productImages: [],
        baseFields: [],
        extraFields: [],
        legalTest: null
      }
      this.init = false
    }
  },
  methods: {
    callback(v) {
      console.log(v)
      v.hsCode && (this.productInfo.legalTest = v.legalTest)
    },
    getcategorytemplate(config) {
      this.loading = true
      this.$store.dispatch('industry/getcategorytemplate', {
        payload: config,
        success: (res) => {
          this.loading = false
          const productBaseTemplate = TemplateFormat.newTemplateFormat(res.data.productBaseTemplate)
          const productExtraTemplate = TemplateFormat.newTemplateFormat(res.data.productExtraTemplate || [])
          this.productInfo.baseFields = productBaseTemplate
          this.productInfo.extraFields = productExtraTemplate
        },
        fail: () => {
          this.loading = false
          this.productInfo.baseFields = []
          this.productInfo.extraFields = []
        }
      })
    },
    getproduct(config) {
      this.loading = true
      this.$store.dispatch('product/getproduct', {
        payload: config,
        success: (res) => {
          this.loading = false
          res.data.productImages = res.data.productImages ? res.data.productImages.split(',').map(item => ({ url: item })) : []
          res.data.baseFields = TemplateFormat.editTemplateFormat(res.data.baseFields)
          res.data.extraFields = TemplateFormat.editTemplateFormat(res.data.extraFields || [])
          this.productInfo = res.data
          this.$nextTick(() => {
            this.init = false
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    update() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const baseFields = TemplateFormat.submitTemplateFormat(clonedeep(this.productInfo.baseFields))
          const extraFields = TemplateFormat.submitTemplateFormat(clonedeep(this.productInfo.extraFields))
          this.loading = true
          this.$store.dispatch('product/updateproduct', {
            payload: {
              ...this.productInfo,
              productImages: this.productInfo.productImages.map(item => item.url).join(','),
              baseFields,
              extraFields
            },
            success: () => {
              this.loading = false
              this.$router.go(-1)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const baseFields = TemplateFormat.submitTemplateFormat(clonedeep(this.productInfo.baseFields))
          const extraFields = TemplateFormat.submitTemplateFormat(clonedeep(this.productInfo.extraFields))
          this.loading = true
          this.$store.dispatch('product/addproduct', {
            payload: {
              ...this.productInfo,
              productImages: this.productInfo.productImages.map(item => item.url).join(','),
              baseFields,
              extraFields
            },
            success: () => {
              this.loading = false
              this.$refs.back.back()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
